import { Injectable } from '@angular/core';
import { forIn, reduce } from 'lodash';
import { Columns, Img, ITable, PdfMakeWrapper, Table } from 'pdfmake-wrapper';
import * as pdf from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import * as moment from 'moment';
import { AtributosService } from './atributos.service';
import { HashKeyServices } from './app.hashkey.services';
import { AppUtilService } from './app.util.service';
import { nkServices } from './app.nkservicios.services';
import { environment } from 'src/environments/environment';
import { ToastNotificationService } from './toast-notification.service';
(<any>pdf).vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: 'root'
})
export class PdfServices {
constructor(
    private servicio:nkServices,
    private atrb:AtributosService,
    private hashkey:HashKeyServices,
    private util:AppUtilService,
    private notifi:ToastNotificationService,
){}

}